// Angular Basic imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { routes } from './webbel-admin-routes';
import { RouterModule } from '@angular/router';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { InvalidmessageDirective } from './directive/invalidMessage.directive';
import { InvalidTypeDirective } from './directive/invalidType.directive';
import { SelectDirective } from './directive/select.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule} from '@angular/common/http';

// components
import { AppComponent } from './app.component';
import { HeaderComponent } from './side-nav/header/header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeMobileappComponent } from './home-mobileapp/home-mobileapp.component';
import { EComicSeriesComponent } from './E-comics/e-comic-series/e-comic-series.component';
import { EComicSeasonsComponent } from './E-comics/e-comic-seasons/e-comic-seasons.component';
import { EComicEpisodeComponent } from './E-comics/e-comic-episode/e-comic-episode.component';
import { EComicSeriesAddComponent } from './E-comics/e-comic-series-add/e-comic-series-add.component';
import { EComicSeasonAddComponent } from './E-comics/e-comic-season-add/e-comic-season-add.component';
import { EComicPricingFormComponent } from './E-comics/e-comic-pricing-form/e-comic-pricing-form.component';
import { EComicEpisodeAddComponent } from './E-comics/e-comic-episode-add/e-comic-episode-add.component';
import { ENovelSeriesComponent } from './E-novels/e-novel-series/e-novel-series.component';
import { ENovelSeasonsComponent } from './E-novels/e-novel-seasons/e-novel-seasons.component';
import { ENovelChapterComponent } from './E-novels/e-novel-chapter/e-novel-chapter.component';
import { ENovelSeriesAddComponent } from './E-novels/e-novel-series-add/e-novel-series-add.component';
import { ENovelSeasonAddComponent } from './E-novels/e-novel-season-add/e-novel-season-add.component';
import { ENovelPricingFormComponent } from './E-novels/e-novel-pricing-form/e-novel-pricing-form.component';
import { ENovelChapterAddComponent } from './E-novels/e-novel-chapter-add/e-novel-chapter-add.component';
import { PartnersComponent } from './Partnerss/partners/partners.component';
import { PartnersListComponent } from './Partnerss/partners-list/partners-list.component';
import { PremiumListComponent } from './premium/premium-list/premium-list.component';
import { PremiumSingleComponent } from './premium/premium-single/premium-single.component';
import { AdminComponent } from './admins/admin/admin.component';
import { UserAddComponent } from './admins/user-add/user-add.component';
import { UserSingleComponent } from './users/user-single/user-single.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { TicketsComponent } from './Ticket/tickets/tickets.component';
import { TicketSingleComponent } from './Ticket/ticket-single/ticket-single.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { AboutUsComponent } from './extras/about-us/about-us.component';
import { TermsConditionsComponent } from './extras/terms-conditions/terms-conditions.component';
import { ChangePasswordComponent } from './extras/change-password/change-password.component';
import { PrivacyPolicyComponent } from './extras/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './extras/refund-policy/refund-policy.component';
import { ContactComponent } from './extras/contact/contact.component';

import { LoginComponent } from './login/login.component';
import { NgxEditorModule  } from 'ngx-editor'
// Services
import {AuthService} from './service/auth.service';
import {EcomicService} from './service/comics/ecomic.service';
import { LoginGuard } from './service/login.guard';
import {ToastModule} from 'ng2-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CalendarModule} from 'primeng/calendar';
// enviroments
import { environment } from '../environments/environment';

// Firebase Requirnments
import {AngularFireModule} from '@angular/fire';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {DetailsService} from './service/details.service';
import { WisSeasonsComponent } from './wis/wis-seasons/wis-seasons.component';
import { WisEpisodesComponent } from './wis/wis-episodes/wis-episodes.component';
import { AddWisSeasonComponent } from './wis/add-wis-season/add-wis-season.component';
import { WisEpisodeAddComponent } from './wis/wis-episode-add/wis-episode-add.component';
import { WisPricingComponent } from './wis/wis-pricing/wis-pricing.component';
import { OurWrittersComponent } from './our-writters/our-writters.component';
import { AddWritterComponent } from './our-writters/add-writter/add-writter.component';
import { SendEmailComponent } from './send-email/send-email.component';
import { EmailHistoryComponent } from './send-email/email-history/email-history.component';
import { AddUserComponent } from './users/add-user/add-user.component';
import { OffersComponent } from './offers/offers.component';
import { AddOfferComponent } from './offers/add-offer/add-offer.component';
import { UpcomingReleasesComponent } from './upcoming-releases/upcoming-releases.component';
import { AddUpcomingReleaseComponent } from './upcoming-releases/add-upcoming-release/add-upcoming-release.component';
import { FcmService } from './service/fcm.service';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    HomeMobileappComponent,
    EComicSeriesComponent,
    EComicSeasonsComponent,
    EComicEpisodeComponent,
    ENovelSeriesComponent,
    ENovelSeasonsComponent,
    ENovelChapterComponent,
    UsersListComponent,
    PremiumListComponent,
    AdminComponent,
    TicketsComponent,
    FeedbackComponent,
    AboutUsComponent,
    TermsConditionsComponent,
    ChangePasswordComponent,
    LoginComponent,
    PartnersComponent,
    EComicSeriesAddComponent,
    EComicSeasonAddComponent,
    EComicPricingFormComponent,
    EComicEpisodeAddComponent,
    ENovelSeriesAddComponent,
    ENovelSeasonAddComponent,
    ENovelPricingFormComponent,
    ENovelChapterAddComponent,
    UserSingleComponent,
    PremiumSingleComponent,
    UserAddComponent,
    TicketSingleComponent,
    InvalidmessageDirective,
    InvalidTypeDirective,
    SelectDirective,
    HeaderComponent,
    PartnersListComponent,
    PrivacyPolicyComponent,
    RefundPolicyComponent,
    ContactComponent,
    WisSeasonsComponent,
    WisEpisodesComponent,
    AddWisSeasonComponent,
    WisEpisodeAddComponent,
    WisPricingComponent,
    OurWrittersComponent,
    AddWritterComponent,
    SendEmailComponent,
    EmailHistoryComponent,
    AddUserComponent,
    OffersComponent,
    AddOfferComponent,
    UpcomingReleasesComponent,
    AddUpcomingReleaseComponent
  ],
  imports: [
    DropzoneModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    NgxEditorModule ,
    HttpClientModule,
    ToastModule.forRoot(),
    CalendarModule
  ],
  providers: [AuthService, DetailsService, EcomicService,FcmService, LoginGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts